import './IngestionSummary.scss';
import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import {SummaryStats} from '../../../shared/types';
import ArrButton from '../../common/arr-button/ArrButton';
import { useNavigate } from 'react-router-dom';

interface StatsDisplayProps {
  stats: SummaryStats;
  showApoUpdates: boolean
}
const IngestionSummary: React.FC<StatsDisplayProps> = ({stats,showApoUpdates}) => {
  const navigate = useNavigate();
  return (
    <Box className="view-ingestionSummary-header">
      <Box className="view-ingestion-title">
        <Typography
          className="typo-text.subhead2_size"
          data-testid={`ingestion-summary-total-mapped-ingestion`}
        >
          {t('ingestions.mapped.totalMappedIngestion')}{' '}
          <Typography
            component="span"
            className="typo-text.body2_size text-body-subtle"
            data-testid={`ingestion-summary-mapped`}
          >
            ({stats.mappedIngests})
          </Typography>
        </Typography>
        <Typography
          className="typo-text.body2_size text-body-subtle "
          data-testid={`ingestion-summary-unique`}
        >
          {`${stats.uniqueIngests} ` +
            t('ingestions.mapped.ingestionsCountText')}
        </Typography>
      </Box>
       { showApoUpdates && (
        <ArrButton
                aria-label={t('ingestions.apoUpdates')}
                type="submit"
                variant="secondary"
                title="APO Updates"
                size="small"
                // TODO : Please change the Route to navigate to the APO History Page
                onClick={() => navigate('/Ingestion/apo')}
                dataTestId="ingestion-header-apoUpdates-btn">
                {t('ingestions.apoUpdates')}
        </ArrButton>)
      }
    </Box>
  );
};

export default IngestionSummary;
